import React from 'react';
import { Box, Container, HStack, Text, Button } from '@chakra-ui/react';
import { MessageCircleIcon } from 'lucide-react';
interface StickyTopBarProps {
  whatsappUrl: string;
}
export function StickyTopBar({
  whatsappUrl
}: StickyTopBarProps) {
  const handleClick = () => {
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };
  return <Box as="header" position="fixed" top={0} left={0} right={0} zIndex={1001} bg="rgba(10, 10, 10, 0.82)" backdropFilter="blur(16px)" borderBottom="1px solid" borderColor="rgba(232, 99, 26, 0.28)" data-id="element-29" data-mp="1uoa5anj70y1">
      <Container maxW="container.xl" px={{
      base: 3,
      md: 6
    }} data-id="element-30" data-mp="frbfo1tjuzfk">
        <HStack justify="space-between" py={{
        base: 2.5,
        md: 3
      }} spacing={3} data-id="element-31" data-mp="kr68wc0ss13s">
          <HStack spacing={2.5} borderWidth="1px" borderColor="rgba(242, 169, 59, 0.35)" bg="rgba(242, 169, 59, 0.08)" borderRadius="full" px={{
          base: 3,
          md: 4
        }} py={1.5} data-id="element-32" data-mp="18gs6ww5foaa7">
            <Box w="7px" h="7px" borderRadius="full" bg="gold.500" boxShadow="0 0 10px rgba(242, 169, 59, 0.9)" flexShrink={0} data-id="element-33" data-mp="20js5txkxrrda" />
            <Text fontSize={{
            base: 'xs',
            md: 'sm'
          }} color="gold.400" fontWeight="semibold" whiteSpace="nowrap" data-id="element-34" data-mp="2ahepsyh3e944">
              Consultas disponibles
            </Text>
          </HStack>

          <Button onClick={handleClick} size="sm" bg="#25D366" color="white" fontWeight="bold" fontSize="xs" textTransform="uppercase" letterSpacing="wide" px={{
          base: 4,
          md: 6
        }} borderRadius="full" leftIcon={<MessageCircleIcon size={15} data-id="element-36" data-mp="yuogaqbmdqtt" />} flexShrink={0} _hover={{
          bg: '#20BA5A',
          transform: 'translateY(-1px)'
        }} _active={{
          transform: 'translateY(0) scale(0.98)'
        }} transition="all 0.2s ease" data-id="element-35" data-mp="2jcchy3cf1hue">
            Contactar
          </Button>
        </HStack>
      </Container>
    </Box>;
}